<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav>
        <ul class="footer-menu">
          <li>
            footer-user
            <!-- <router-link :to="{path:'/user'}">Dashboard</router-link> -->
          </li>
        </ul>
      </nav>
    </div>
  </footer>
</template>
<script>
export default {
  name: "FooterUser",
};
</script>
<style></style>
